import { deleteDonorAccount, logout } from "appState/auth/authSlice";
import DonateCard from "features/HomePage/components/DonateCard";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

const DonorFavourites = () => {
  const { donor } = useSelector((state) => state.auth);

  const theme = ["bg-[#FF8F41]", "bg-[#61CE70]", "bg-[#0693E3]"];

  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-6 my-4 items-start">
      <div className="px-12 py-6 bg-white border border-[#838383]">
        <p className="text-[16px] text-[#213874]">Favourites</p>
        {donor?.donor?.favourites?.length > 0 ? (
          <div className="mt-5 flex gap-6 justify-center max-md:flex-wrap">
            {donor?.donor?.favourites?.map((donateCard, idx) => (
              <div key={donateCard._id}>
                <DonateCard
                  id={donateCard._id}
                  cardImage={donateCard.project_picture}
                  title={donateCard.name}
                  body={donateCard.summary}
                  amountRaised={donateCard.amountDonated}
                  targetAmount={donateCard.fundraising_goal}
                  bgColor={theme[idx % 3]}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-5">
            <p className="text-[#7A7A7A]">
              You do not have any favorite projects yet. To mark a project as a
              "favorite". Select the heart on the right side of any project
              page. Explore our projects by theme and location, and find some
              favorites!
            </p>
            <div className="flex justify-center items-center">
              <Link to="/projects">
                <button
                  type="button"
                  className="bg-[#213874] my-2 hover:bg-[#11224d] text-white py-2 px-8 rounded-3xl"
                >
                  Find a Project
                </button>
              </Link>
            </div>
          </div>
        )}
      </div>
      <div className="w-full flex justify-end items-end">
        <p
          onClick={() => {
            dispatch(deleteDonorAccount()).then((data) => {
              const { payload } = data;
              if (payload?.status === 200) {
                dispatch(logout());
                navigate("/auth/donor/login");
              }
            });
          }}
          className="cursor-pointer py-3 px-8 border hover:bg-[#f4dfdf] text-[#C81818] border-[#C81818]"
        >
          Delete my account
        </p>
      </div>
    </div>
  );
};

export default DonorFavourites;
